import {
  ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
} from "../constants";

export const PLATFORM_DEFAULTS_EMPTY_VALUES = {
  [META]: {
    objective: "",
    integrationID: "",
    adAccountID: "",
    pageID: "",
    instagramID: "",
    useFBPageAsIG: false,
    destinationType: ADS_CAMPAIGN_META_DESTINATION_TYPE_WEBSITE_OPTION,
    catalogID: "",
    trackingID: "",
    appPromotion: "",
    appID: "",
    isIOS14Campaign: true,
  },
  [TIKTOK]: {
    objective: "",
    type: "",
    integrationID: "",
    adAccountID: "",
    identityTikTokID: "",
    catalogID: "",
    trackingID: "",
    appPromotion: "",
    appID: "",
    isIOS14Campaign: true,
  },
  [GOOGLE]: {
    objective: "",
    integrationID: "",
    adAccountID: "",
    merchantCenterID: "",
    appStore: "",
    appID: "",
  },
  [LINKEDIN]: {
    objective: "",
    integrationID: "",
    adAccountID: "",
    adFormat: "",
  },
};

export const getPlatformDefaultsEmptyValues = ({ platform }) =>
  PLATFORM_DEFAULTS_EMPTY_VALUES[platform] || {};
